/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'confluence-analytics-chart.default-loading-text': 'Refreshing analytics data...',
  'confluence-analytics-chart.tooltip.no-views-data': 'No data',
  'confluence-analytics-chart.tooltip.views-overall': '{count, plural, one {1 view} other {{count} views}}',
  'confluence-analytics-chart.tooltip.views-today-so-far':
    '{count, plural, one {1 view so far} other {{count} views so far}}',
  'confuence-analytics-chart.accessible-table.caption': 'Page views',
  'confuence-analytics-chart.accessible-table.header.date': 'Date',
  'confuence-analytics-chart.accessible-table.header.view-count': 'Views',
  'confuence-analytics-chart.accessible-table.no-view-count-data': 'No views',
};
